import {
  GetClimateSurveyInsightsDocument,
  GetClimateSurveyInsightsQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type SurveyCategoryScores =
  GetClimateSurveyInsightsQuery['engagementInsights']['climateSurveyInsightsConnection']['nodes'][number]['surveyCategoryScores']

interface Params {
  managerId?: string
}

export const useClimateSurveyInsight = ({ managerId }: Params = {}) => {
  const { loading, data, refetch } = useQuery(GetClimateSurveyInsightsDocument, {
    variables: { managerId },
  })

  const nodes = data?.engagementInsights.climateSurveyInsightsConnection.nodes ?? []
  const climateSurveyInsight = nodes[0] ?? null

  return {
    loading,
    climateSurveyInsight,
    refetch,
  }
}
